import { SortRequest } from "./types/request"

export const Collation = {
    PRIMARY: "primary",
    SECONDARY: "secondary",
    TERTIARY: "tertiary",
    IDENTICAL: "identical"
}

export class Sort {
    private _fields: SortRequest[]
    private _type: string | null
    private _characteristic: string | null
    private _collation: string | null

    constructor() {
        this._fields = []
        this._type = null
        this._characteristic = null
        this._collation = null
    }

    /**
     * Sort by ID
     * @returns this
     */
    id(): this {
        this._type = "id"
        this._characteristic = null
        return this
    }

    /**
     * Sort by name
     * @returns this
     */
    name(): this {
        this._type = "name"
        this._characteristic = null
        return this
    }

    /**
     * The characteristic ID.
     * @param {String} name the characteristic name
     * @returns this
     */
    characteristic(name: string): this {
        this._characteristic = name
        this._type = "characteristic"
        return this
    }

    /**
     * The collation strength.
     * Possible values: primary, secondary, tertiary, identical (for number-characteristics only "identical" is valid)
     * If not specified, the default value of the underlying appbase-catalogue is used.
     */
    collation(
        strength: "primary" | "secondary" | "tertiary" | "identical"
    ): this {
        this._collation = strength
        return this
    }

    /**
     * Sort ascending or descending.
     * @param {Boolean} [enabled] true or undefined: asc, otherwise: desc
     * @returns this
     */
    asc(enabled: boolean): this {
        const result: SortRequest = {
            order: enabled === false ? "desc" : "asc"
        }
        if (this._type !== null) {
            result.type = this._type
        }
        if (this._characteristic !== null) {
            result.characteristicId = this._characteristic
        }
        if (this._collation !== null) {
            result.collation = this._collation
        }

        this._type = null
        this._characteristic = null
        this._collation = null

        this._fields.push(result)
        return this
    }

    /**
     * Sort descending or ascending.
     * @param {Boolean} [enabled] true or undefined: desc, otherwise: asc
     * @returns this
     */
    desc(enabled: boolean): this {
        const result: SortRequest = {
            order: enabled === false ? "asc" : "desc"
        }
        if (this._type !== null) {
            result.type = this._type
        }
        if (this._characteristic !== null) {
            result.characteristicId = this._characteristic
        }
        if (this._collation !== null) {
            result.collation = this._collation
        }

        this._type = null
        this._characteristic = null
        this._collation = null

        this._fields.push(result)
        return this
    }

    build(): SortRequest[] {
        return this._fields
    }
}
